import React from "react";
import { Dropdown, Space } from "antd";
import useAuth from "../../hooks/useAuth";
import { logoutUser } from "../../hooks/logoutUser";
import { ChevronDown } from "lucide-react";

const SelectProfile = () => {
  const { auth, setAuth } = useAuth();

  const logout = () => {
    logoutUser(auth, setAuth); // ✅ handles everything
  };
  const items = [
    {
      label: "User Profile",
      key: "0",
    },
    {
      label: "Account Settings",
      key: "1",
    },
    {
      label: "Support",
      key: "3",
    },
    {
      label: "Logout",
      key: "4",
      onClick: logout,
    },
  ];
  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      placement="topRight"
      className="cursor-pointer"
    >
      <Space
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: 150,
        }}
      >
        {`${auth?.user?.firstname} ${auth?.user?.lastname}`}
        <ChevronDown />
      </Space>
    </Dropdown>
  );
};

export default SelectProfile;
